import { createTheme } from '@mui/material/styles'
import type {} from '@mui/x-data-grid/themeAugmentation'
import './expanded-theme'
import './fonts'

const theme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: [
      'Open Sans',
      'Sanomat',
      'Sanomat-Medium-Web',
      'Sanomat-MediumItalic-Web',
      'Atlas-Grotesk-Bold',
      'Atlas-Grotesk-Web-Light',
      'Atlas-Grotesk-Web-Regular-Italic',
      'Atlas-Grotesk-Web-Regular',
      'Atlas-Typewriter-Regular',
      'Atlas-Typewriter-Web-Regular',
      'Atlas-Typewriter-Light-Italic',
      'Atlas-Typewriter-Light',
      'Atlas-Typewriter-Medium-Italic',
      'Atlas-Typewriter-Medium',
      'Atlas-Typewriter-Regular-Italic',
      'Atlas-Typewriter-Regular',
      'Atlas-Typewriter-Web-Regular',
    ].join(','),
    h1: {
      fontSize: '34px',
      fontFamily: 'Sanomat-Medium-Web',
      fontWeight: '500',
      letterSpacing: '0.25px',
    },
    h2: {
      fontFamily: 'Sanomat-Medium-Web',
      fontWeight: '500',
      fontSize: '24px',
    },
    h3: {
      fontFamily: 'Sanomat-Medium-Web',
      fontWeight: '500',
      fontSize: '20px',
    },
    h4: {
      fontFamily: 'Sanomat-Medium-Web',
      fontWeight: '500',
      fontSize: '16px',
    },
    h5: {
      fontFamily: 'Atlas-Grotesk-Web-Regular',
      fontSize: '15px',
    },
    h6: {
      fontFamily: 'Atlas-Grotesk-Web-Regular',
      fontSize: '17px',
    },
    allVariants: {
      fontFamily: ['Atlas-Grotesk-Web-Regular'].join(','),
      fontSize: 16,
    },
    navTitle: {
      fontSize: '16px',
      color: '#676767',
      fontFamily: 'Open Sans',
      fontWeight: '400',
      letterSpacing: '0',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        text: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontFamily: 'Atlas-Grotesk-Web-Regular',
          letterSpacing: '0.37px',
          color: '#676767',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          height: '56px',
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          navTitle: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
        },
      },
    },
  },
  palette: {
    white: {
      main: '#FFFFFF',
    },
    black: {
      main: '#000000',
    },
    ltgray: {
      main: '#B9B9B9',
    },
    blue: {
      main: '#00529b',
    },
  },
})

export default theme
